import { format } from "date-fns";
import { FISCAL_YEAR_MILLENNIUM, getFiscalYearFromDate, getFiscalYearPeriod, } from "./forecastDateUtils";
export const groupDriversByName = (driverList) => {
    const groups = new Map();
    for (const driver of driverList) {
        const existing = groups.get(driver.name);
        if (existing === undefined) {
            groups.set(driver.name, {
                displayName: driver.displayName !== "" ? driver.displayName : driver.name,
                driverIds: [driver.id],
            });
        }
        else {
            existing.driverIds.push(driver.id);
        }
    }
    return Array.from(groups, ([name, value]) => ({
        name,
        displayName: value.displayName,
        driverIds: value.driverIds,
    }));
};
export const resolveDateRange = (dateKey) => {
    const { fyStart, fyEnd } = getFiscalYearPeriod(getFiscalYearFromDate(dateKey));
    return {
        startDate: format(fyStart, "yyyy-MM-dd"),
        endDate: format(fyEnd, "yyyy-MM-dd"),
    };
};
export const getFiscalYearLabel = (dateKey) => `FY${FISCAL_YEAR_MILLENNIUM + getFiscalYearFromDate(dateKey)}`;
//# sourceMappingURL=downloadForecastTransforms.js.map